export const baseState = {
    executives: [],
    currentExecutive: {},
    estates: [],
    currentEstatePage: 1,
    getNewEstates: true,
    houses: [],
    sliders: [],
    currentHouse: {},
    subscribeResponse: '',
    subscribeStatus: false,
    privacyContent: '',
    siteData: {},
    articles: [],
    currentArticlePage: 1,
    getNewPages: true,
    currentArticle: {},
    mapAvailable: false,
    mapAPIKey: '',
    brochure_url: '',
    agent_form_url: '',
    contactOffices: [],
    testimonials: [],
    contactData: {},
    loadingState: true
}